module.exports = __webpack_public_path__ + "img/male1&yuriko.91e9bb44.jpg";